module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mc-b5edb75519037dcf483e8d845b7af989.svg";